import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
import onMessageReadEventCompleted from 'owa-addins-store/lib/actions/onMessageReadEventCompleted';
import onReadItemSwitch from 'owa-addins-store/lib/actions/onReadItemSwitch';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AddinsDecryption" */ './lazyIndex'),
    {
        name: 'AddinsDecryption',
    }
);

export const lazyProcessItemForDecryption: LazyAction<
    typeof lazyIndex.processItemForDecryption,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.processItemForDecryption);

registerLazyOrchestrator(
    onMessageReadEventCompleted,
    lazyModule,
    m => m.messageReadEventCompletedOrchestrator
);

registerLazyOrchestrator(onReadItemSwitch, lazyModule, m => m.readItemSwitchOrchestrator);
